<mat-dialog-content class="picture-dialog-content">
    @if (images.length > 1) {
        <div class="thumbnails">
            @for (image of images; track image; let i = $index;) {
                <span [id]="'picture-{{i}}'"
                    style="padding-right: 15px;">
                    <img class="thumbnail"
                        [style.border]="showPictureIndex === i ? '2px solid red' : 'none'"
                        [class.mobile]="mobile"
                        (click)="selectPicture(i);"
                        [src]="images[i]">
                </span>
            }
        </div>
    }
    <button class="close-button"
        (click)="closeZoomDialog()">
        <mat-icon>close
        </mat-icon>
    </button>
    <div class="zoom-container"
        (wheel)="onWheel($event)"
        (mousedown)="startPan($event)"
        (mousemove)="onPan($event)"
        (mouseup)="endPan()"
        (mouseleave)="endPan()"
        [style.transform]="transformStyle">
        <img [src]="images[showPictureIndex]"
            class="zoomed-picture">
    </div>
</mat-dialog-content>